import React from 'react';
import GlossaryImage from './Glossary.svg';
import {Image} from '@learningblocks/storybook-components';
import style from './style.module.scss';

export function GlossaryLogo() {
  return (
    <div className={style.glossaryLogo}>
      <Image src={GlossaryImage} alt='Glossary Logo' />
      <h3>Glossary</h3>
    </div>
  );
}

GlossaryLogo.propTypes = {};

GlossaryLogo.defaultProps = {};
